import React from 'react';
import 'LIBRARY/Footer/footer.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Popover } from 'react-tiny-popover';
import config from 'config';
import LibraryApiCall from 'LibraryApiCall';
import 'react-toastify/dist/ReactToastify.css';
import { ToastContainer, toast } from 'react-toastify';
import copyIC from 'LIBRARY/assets/ic.png'

class Footer extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            defaultNumber: '',
            primarySPOCNumber: '',
            showPopOver: false
        }
    }

    componentDidMount() { this.apiCallToGetCallerId(); }

    apiCallToGetCallerId = async () => {
        try {
            // Make an API call to retrieve caller IDs
            const jsonResponse = await LibraryApiCall.makeApiCall('getCallerIds', { instituteId: config.institute_id }, '/api/helpDesk.php');
            // Check if the response indicates that the session expired
            if (jsonResponse.expired) {
                // Retry the API call after a delay if the session expired
                setTimeout(this.apiCallToGetCallerId, 1000);
            } else {
                // Process the response if the API call was successful
                if (jsonResponse.success) {
                    const { defaultCallerId, primarySPOCCallerId } = jsonResponse.APIResult; // Extract default and primary SPOC caller IDs from the response
                    this.setState({ defaultNumber: defaultCallerId, primarySPOCNumber: primarySPOCCallerId }); // Update state with retrieved caller IDs
                }
            }
        } catch (error) {
            // Handle any errors that occur during the API call
            console.error('Error in API call:', error);
        }
    };

    renderPopoverContent = () => {
        const { defaultNumber, primarySPOCNumber } = this.state;
        return (
            <div className='popOverBody p-2 ml-5'>
                <div className="popoverBody mb-3">
                    <label className='m-0 pt-2 labelText3'>Got questions? Dial us!</label>
                </div>
                <div className="d-flex align-items-center row justify-content-center mb-1">
                    <label className='m-0 mr-4 labelText1'>{defaultNumber || ""}</label>
                    <span style={{ cursor: 'pointer' }} onClick={() => this.copyToClipboard(defaultNumber)}>
                        <img className="apple-icon cursor-pointer" style={{ width: 20, height: 20, alignSelf: 'center' }} src={copyIC} />
                    </span>
                </div>
                {
                    primarySPOCNumber !== "" && (
                        <div className="d-flex align-items-center row justify-content-center">
                            <label className='m-0 mr-4 labelText1'>{primarySPOCNumber || ""}</label>
                            <span style={{ cursor: 'pointer' }} onClick={() => this.copyToClipboard(primarySPOCNumber)}>
                                <img className="apple-icon cursor-pointer" style={{ width: 20, height: 20, alignSelf: 'center' }} src={copyIC} />
                            </span>
                        </div>
                    )
                }
                <div className="popoverFooter mt-3">
                    <label className='m-0 pt-2 labelText'>Please <label className='m-0 pt-2 text-danger labelText1' style={{ textTransform: 'none !important' }}> do not save these virtual contact numbers,</label></label>
                    <span className='m-0 pb-2 labelText'>as they may keep changing.  </span>
                </div>
            </div>
        );
    }

    copyToClipboard = (phoneNumber) => {
        try {
            navigator.clipboard.writeText(phoneNumber);
            this.setState({ showPopover: false }); // Hide the popover after copying
            toast("Copied to clipboard successfully...");
        } catch (e) {
            // console.log(e);
            toast("Failed to copy...");
        }
    }

    render() {
        const { defaultNumber, primarySPOCNumber, showPopOver } = this.state;
        return (
            <footer id="footer" className="big sticky-footer">
                <div className="footer-container">
                    {
                        config.account == "faculty" &&
                        <a style={{ float: 'left' }} href={`${config.RootUrl}/modules/helpdesk/#/help/productDocumentation`} target="_blank" rel="noopener noreferrer" className="footer-link ml-4">
                            <span className="helpBtn">
                                Product Documentation
                            </span>
                        </a>
                    }
                    {
                        config.account == "faculty" &&
                        <Popover
                            isOpen={showPopOver}
                            padding={5}
                            arrowSize={10}
                            arrowColor="#000000"
                            containerStyle={{ borderRadius: 10, zIndex: '20px !important' }}
                            positions={['top', 'right']} // preferred positions by priority
                            onClickOutside={() => this.setState({ showPopOver: false })}
                            content={this.renderPopoverContent()}
                        >
                            <button className="contactBtn ml-2 mb-1" style={{ float: 'left' }} type="button" onClick={() => this.setState({ showPopOver: !showPopOver })}>
                                <FontAwesomeIcon className="apple-icon" icon={['fa', 'phone-alt']} size="xs" />
                                <span className="contactBtn">
                                    Contact US
                                </span>
                            </button>
                        </Popover>
                    }
                    <span className="footer-data download">Download App
                        <a href="https://play.google.com/store/apps/details?id=com.vmedulifeapp&hl=en_IN" target="_blank" rel="noopener noreferrer" className="footer-link">
                            <span className="footer-data download">
                                <img style={{ height: 16 }} className='android-logo ml-2 img-fluid' src={process.env.PUBLIC_URL + "/assets/images/android_icon.png"} alt="image" />
                            </span>
                        </a>
                        <a href="https://apps.apple.com/app/vmedulife/id1606317107" target="_blank" rel="noopener noreferrer" className="footer-link">
                            <span className="footer-data download ml-2">
                                <FontAwesomeIcon className="apple-icon" icon={['fab', 'apple']} size="lg" />
                            </span>
                        </a>
                    </span>
                    <a href="https://vmedulife.com/privacy-policy" target="_blank" rel="noopener noreferrer" className="footer-link">
                        <span className="footer-data policy">Privacy Policy</span>
                    </a>
                    <a href="https://vmedulife.com/terms-of-service" target="_blank" rel="noopener noreferrer" className="footer-link">
                        <span className="footer-data terms">Terms of Use</span>
                    </a>
                    <a href="https://vmedulife.com/" target="_blank" rel="noopener noreferrer" className="footer-link">
                        <span className="footer-data powered-by">
                            Powered by<span className="vm" style={{ marginLeft: "0.2%" }}>vm</span><span className="edu">edu</span><span className="life">life</span>
                        </span>
                    </a>
                </div>
                {/* <ToastContainer /> */}
            </footer>
        );
    }
}

export default Footer;